import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { getAllLoadedTimestampsByComponentDesignGuid } from './getAllLoadedTimestampsByComponentDesignGuid';

export const getDoWorkingChangesExistByLoadedComponentDesignGuid = createSelector(
  getAllLoadedTimestampsByComponentDesignGuid,

  (componentDesignTimestamps) =>
    mapValues(componentDesignTimestamps, (timestamps) => {
      const { lastAnalyzed, lastUpdated } = timestamps;
      const notAnalyzed = lastAnalyzed === null;
      if (notAnalyzed) return true;
      const areWorkingChanges = new Date(lastUpdated) > new Date(lastAnalyzed);
      return areWorkingChanges;
    }),
);
